import { ArabicEach } from '@/mm/utils.js'

export function washData(walkedNode) {
  let ArabicRule = [
    {
      flag: 'product_list_title',
      dataType: ['design'],
      onlyEnglish: ['title_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    },
    {
      flag: 'product_list_button',
      dataType: ['design'],
      onlyEnglish: [false],
      englishTitleLeft: ['self_marginLeft'],
      englishTitleRight: ['self_marginRight']
    },
    {
      flag: 'product_right_title',
      dataType: ['design', 'design'],
      onlyEnglish: ['title_textAlign', false],
      englishTitleLeft: ['left', 'self_marginLeft'],
      englishTitleRight: ['right', 'self_marginRight']
    },
    {
      flag: 'product_list_paragraph',
      dataType: ['design', 'design'],
      onlyEnglish: ['title_textAlign', false],
      englishTitleLeft: ['left', 'self_marginLeft'],
      englishTitleRight: ['right', 'self_marginRight']
    },
    {
      flag: 'product_right_button',
      dataType: ['design'],
      onlyEnglish: [false],
      englishTitleLeft: ['self_marginLeft'],
      englishTitleRight: ['self_marginRight']
    }
  ]
  ArabicEach(walkedNode, ArabicRule)
}
